import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import { SlashMenu } from './SlashMenu';
import { Type, Heading1, Heading2, Heading3, List, ListOrdered, CheckSquare, Quote, GripVertical, Minus } from 'lucide-react';

export const suggestion = {
    items: ({ query }) => {
        return [
            {
                title: 'Text',
                icon: <Type size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).setNode('paragraph').run();
                },
            },
            {
                title: 'Heading 1',
                icon: <Heading1 size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).setNode('heading', { level: 1 }).run();
                },
            },
            {
                title: 'Heading 2',
                icon: <Heading2 size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).setNode('heading', { level: 2 }).run();
                },
            },
            {
                title: 'Bullet List',
                icon: <List size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).toggleBulletList().run();
                },
            },
            {
                title: 'Numbered List',
                icon: <ListOrdered size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).toggleOrderedList().run();
                },
            },
            {
                title: 'To-do List',
                icon: <CheckSquare size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).toggleTaskList().run();
                },
            },
            {
                title: 'Quote',
                icon: <Quote size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).setBlockquote().run();
                },
            },
            {
                title: 'Divider',
                icon: <Minus size={18} />,
                command: ({ editor, range }) => {
                    editor.chain().focus().deleteRange(range).setHorizontalRule().run();
                },
            },
        ].filter(item => item.title.toLowerCase().startsWith(query.toLowerCase())).slice(0, 10);
    },

    render: () => {
        let component;
        let popup;

        return {
            onStart: props => {
                component = new ReactRenderer(SlashMenu, {
                    props,
                    editor: props.editor,
                });

                if (!props.clientRect) {
                    return;
                }

                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                });
            },

            onUpdate(props) {
                component.updateProps(props);

                if (!props.clientRect) {
                    return;
                }

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                });
            },

            onKeyDown(props) {
                if (props.event.key === 'Escape') {
                    popup[0].hide();

                    return true;
                }

                return component.ref?.onKeyDown(props);
            },

            onExit() {
                popup[0].destroy();
                component.destroy();
            },
        };
    },
};
